// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-eebe87e0] {\n  max-height: calc(100vh - 230px) !important;\n}\n.color-example[data-v-eebe87e0] {\n  height: 30px;\n  width: 30px;\n  background: #000;\n  margin-right: 15px;\n  border-radius: 2px;\n}\n.category-name-wrapper[data-v-eebe87e0] {\n  display: flex;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
